// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"b06fefbb","80":"f488f13c","251":"32600d60","723":"48f2a6bf","724":"acae59bd","736":"a027e3da","742":"522b8297","770":"fdc7c9de"}[chunkId] + ".chunk.css";
};